/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { Component } from "react";
import styled from "styled-components";
import { NanoFlex } from "../NanoFlex.js";
import Typography from "../Typography.js";

const StyledList = styled(NanoFlex)`
  display: flex;
  height: auto;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  margin-left: 5vw;

  .listElement {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 12px;
    letter-spacing: 0.2px;
    color: #252733;
    opacity: 0.7;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: flex-start;
    align-items: center;

    .circle {
      height: 10px;
      width: 10px;
      border-radius: 10px;
      margin-right: 13px;
    }
  }
`;

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: this.props.options ?? [],
    };
  }

  render() {
    return (
      <StyledList>
        {this.state.options.map((m, i) => {
          return (
            <NanoFlex className="listElement" key={`${i}_${m}`}>
              <NanoFlex className="circle" color={m.color}></NanoFlex>
              <Typography.p>{m.name}</Typography.p>
            </NanoFlex>
          );
        })}
      </StyledList>
    );
  }
}

export default List;
